module.exports = __webpack_public_path__ + "static/img/core-item-2.914ff5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/core-item-2.png
// module id = +UZm
// module chunks = 0